import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=774fe62c&scoped=true&"
import script from "./Box.vue?vue&type=script&lang=ts&"
export * from "./Box.vue?vue&type=script&lang=ts&"
import style0 from "./Box.vue?vue&type=style&index=0&id=774fe62c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774fe62c",
  null
  
)

export default component.exports